import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { publicApi, formatApiErrorDetail } from "@/lib/api";

export default function PublicFooter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await publicApi.post("/subscribe", { email });
      toast.success("You're subscribed. Welcome aboard.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  const col = "flex flex-col gap-2.5 text-sm text-white/70";
  const linkCls = "transition-colors hover:text-white";

  return (
    <footer className="bg-[#18344A] text-white">
      <div className="mx-auto max-w-[1280px] px-5 py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/assets/logo-white.png" alt="Pack Brothers Hospitality" className="h-14 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/70">
              A family-owned collection of restaurants, waterfront escapes, marinas, and gathering places rooted in Coastal Virginia.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white/90">Explore</h4>
            <div className={col}>
              <Link to="/story" className={linkCls}>Our Story</Link>
              <Link to="/portfolio" className={linkCls}>Portfolio</Link>
              <Link to="/experiences" className={linkCls}>Experiences</Link>
              <Link to="/happenings" className={linkCls}>Happenings</Link>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white/90">Company</h4>
            <div className={col}>
              <Link to="/press" className={linkCls}>Press &amp; Accolades</Link>
              <Link to="/scholarships" className={linkCls}>Scholarships</Link>
              <Link to="/contact" className={linkCls}>Contact</Link>
              <Link to="/login" className={linkCls}>Team Login</Link>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-white/90">Stay in the Loop</h4>
            <p className="mb-3 text-sm text-white/70">News, events, and seasonal happenings across the portfolio.</p>
            <form onSubmit={subscribe} className="flex overflow-hidden rounded-full border border-white/20 bg-white/5" data-testid="footer-subscribe-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                data-testid="footer-subscribe-email"
                className="w-full bg-transparent px-4 py-2.5 text-sm text-white placeholder:text-white/40 focus:outline-none"
              />
              <button type="submit" disabled={busy} data-testid="footer-subscribe-submit" className="bg-[#B7A58E] px-4 text-sm font-semibold text-[#18344A]">
                Join
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/12 pt-6 text-xs text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} Pack Brothers Hospitality. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <span>Coastal Virginia</span>
            <Link to="/contact" className="hover:text-white/80">Accessibility</Link>
            <Link to="/contact" className="hover:text-white/80">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
